import React, { createContext, useContext } from "react";
import type { TierListDataVersionContext } from "./dataVersion";

const TierListDataContext = createContext<TierListDataVersionContext | null>(null);

export const TierListDataProvider: React.FC<
  React.PropsWithChildren<TierListDataVersionContext>
> = ({ children, version, dataRoot }) => (
  <TierListDataContext.Provider value={{ version, dataRoot }}>
    {children}
  </TierListDataContext.Provider>
);

export function useTierListData(): TierListDataVersionContext {
  const context = useContext(TierListDataContext);

  if (!context) {
    throw new Error("useTierListData must be used within TierListDataProvider");
  }

  return context;
}
